import request from 'api/request';

export default function cancelTicketRoute(id) {
  return request({ url: `/tickets/${id}/cancel`, method: 'POST' });
}
